import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import UpdateFlowStep from './UpdateFlowStep'

class LegalAndExtrasStep extends UpdateFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.update.steps.legal_and_extras.title'),
      component,
      i18n.t('contract_versions.flows.update.steps.legal_and_extras.description')
    )
  }
}

export default LegalAndExtrasStep
